import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import * as uuid from 'uuid';
import { Stripe, StripeCardElement } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

import { EnvironmentConfig, GeneralService, PaymentService } from '@clooper/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-input-debit-card',
  templateUrl: './input-debit-card.component.html',
  styleUrls: ['./input-debit-card.component.scss']
})
export class InputDebitCardComponent implements AfterViewInit {

  id = 'card-' + uuid.v4();

  private stripe: Stripe;
  private card: StripeCardElement;

  @Output() paymentSuccess: EventEmitter<any> = new EventEmitter;
  @Output() isLoading: EventEmitter<boolean> = new EventEmitter;
  paymentType: string | undefined;

  constructor(
    private config: EnvironmentConfig,
    private toastr: ToastrService,
    private paymentService: PaymentService,
    private gs: GeneralService
  ) { }

  ngAfterViewInit() {
    this.loadStripe()
    
  }

  private loadStripe(): Promise<any> {
    return loadStripe(this.config.stripePk).then((stripe: any) => {
      this.stripe = stripe;
      // attach to element
      setTimeout(() => {
        const element = this.stripe?.elements();
        const style = {
          base: {
            color: '#32325d',
            fontFamily: 'Poppins, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
              color: '#32325d'
            }
          },
          invalid: {
            fontFamily: 'Poppins, sans-serif',
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        };
        this.card = element?.create('card', { style, hidePostalCode: true })
        this.card.mount(`#${this.id}`);
        this.card.on('change', (event: any) => {
      console.log(event);
      
    });
      }, 200);
    }).catch(err => {
    });
  }

  pay(payload: any, type?: string) {
    this.paymentType = type;
    if (type !== 'subscription') {
      this.paymentService.initiatePayment(payload).subscribe((res: any) => {
        if (res.error) return
        const clientSecret = res.data.client_secret;
        this.completePayment(clientSecret);
      }, err => {
        this.isLoading.emit(false);
        this.toastr.error(this.gs.getErrMsg(err));
      });

    } else {

      this.paymentService.initiateSubscriptionPayment(payload).subscribe((res: any) => {
        if (res.error) return
        const clientSecret = res.data.client_secret;
        this.completePayment(clientSecret);
      }, err => {
        this.isLoading.emit(false);
        this.toastr.error(this.gs.getErrMsg(err));
      });
    }
  }

  private completePayment(clientSecret: string) {
    const option = { payment_method: { card: this.card } }
    this.stripe.confirmCardPayment(clientSecret, option).then((result: any) => {
      if (result.error) {
        this.toastr.error(result.error.message);
        // this.loadingPayment = false;
      } else {
        const { status, id } = result.paymentIntent;
        if (status === 'succeeded') {
          this.toastr.success('Payment Successful');
          if (this.paymentType !== 'subscription') {

            this.verifyPayment(id);
          } else {
            this.verifySubscriptionPayment(id);

          }
          this.paymentSuccess.emit(result.paymentIntent);
        } else {
          this.toastr.error('Payment Failed')
          // this.loadingPayment = false;
        }
      }
    }).catch(err => {
      // this.loadingPayment = false;
    })

  }

  private verifyPayment(id: string) {
    this.paymentService.verifyPayment(id).subscribe(resp => {
    })
  }

  private verifySubscriptionPayment(id: string) {
    this.paymentService.verifySubscriptionPayment(id).subscribe(resp => {
    })
  }

}
